var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('button', {
    class: ['t-button', _vm.baseClass],
    attrs: {
      "disabled": _vm.disabled
    },
    on: {
      "click": _vm.handleClick
    }
  }, [_c('span', {
    staticClass: "t-label"
  }, [_c('span', {
    class: ['t-icon-spot', _vm.iconClass]
  }), _c('span', {
    staticClass: "t-label-text"
  }, [_vm._t("default")], 2)])]);
}
var staticRenderFns = []

export { render, staticRenderFns }